import React from 'react'
import { Button } from '@mui/material'
import { useNotify, useTranslate } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { ApplyToEnglishButtonType } from './type'

const defaultSourceFields = {
  title_th: 'title_en',
  short_description_th: 'short_description_en',
  description_th: 'description_en',
  branch_th: 'branch_en',
  experience_th: 'experience_en',
}

const ApplyToEnglishButton: React.FC<ApplyToEnglishButtonType> = ({
  label = 'ra.action.apply_english',
  sourceFields = defaultSourceFields,
  updateKeyEditor,
  ...props
}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { setValue, getValues } = useFormContext()
  const handleClick = (): void => {
    const value = getValues()
    for (const sourceFieldKey in sourceFields) {
      setValue(sourceFields[sourceFieldKey], value[sourceFieldKey])
    }
    updateKeyEditor()
    notify('ra.message.apply_english')
  }

  return (
    <Button
      variant='text'
      size='medium'
      fullWidth
      sx={{ maxWidth: { xs: '100%', md: 'fit-content' } }}
      onClick={handleClick}
      {...props}
    >
      {translate(label)}
    </Button>
  )
}
export default ApplyToEnglishButton
